export default __webpack_public_path__ + "static/media/arrivchart.71fee9f6.svg";